import gql from 'graphql-tag'
import { transformObject } from '../common/helpers'

export const gqlUpdateBusiness = gql`
  mutation editarUsuarioJuridico(
    $nomeFantasia: String!
    $faturamentoMedioMensal: String!
    $cnaePrincipal: String!
    $tipoUsuario: String!
    $adesaoPap: Boolean
    $documento: String
  ) {
    editarUsuarioJuridico(
      usuarioJuridico: {
        nomeFantasia: $nomeFantasia
        faturamentoMedioMensal: $faturamentoMedioMensal
        cnaePrincipal: $cnaePrincipal
        tipo: $tipoUsuario
      }
    ) {
      nomeFantasia
      faturamentoMedioMensal
      cnaePrincipal
    }
    mudarSituacaoPap(adesaoPap: $adesaoPap, documento: $documento) {
      adesaoPap
      documento
    }
  }
`

export const gqlBusinessUserOnly = gql`
  {
    usuario {
      customerId
      cnpj
      nomeFantasia
      razaoSocial
      dataConstituicao
      formaConstituicao {
        longDesc
      }
      cnaePrincipal
      inscricaoMunicipal
      faturamentoMedioMensal
      enderecos {
        bairro
        cep
        cidade
        codigo
        complemento
        correspondencia
        logradouro
        numero
        uf
      }
    }
  }
`

export const gqlBusiness = gql`
  {
    usuario {
      customerId
      cnpj
      nomeFantasia
      razaoSocial
      dataConstituicao
      formaConstituicao {
        longDesc
      }
      cnaePrincipal
      inscricaoMunicipal
      faturamentoMedioMensal
      enderecos {
        bairro
        cep
        cidade
        codigo
        complemento
        correspondencia
        logradouro
        numero
        uf
      }
    }
    contatoAdministrador {
      celular {
        ddd
        id
        numero
        tipoTelefone
      }
      email {
        id
        enderecoEletronico
        # additionDate - "20180521000000000" chega nesse formato pelo middlaew
        newsletter
      }
      # identificationNumber: null
      nome {
        nomeCompleto
        id
        # emiteNotaFiscal - false chega neste formato pelo middleware
      }
      site {
        enderecoEletronico
      }
      # telefone: null
      telefone {
        id
        ddd
        numero
        tipoTelefone
        ramal
      }
    }
    representantes {
      nome
      cpf
      nacionalidade
      tipoRelacao {
        id
        longDesc
        nemotecnico
        shortDesc
      }
      email
      celular
    }
  }
`

export const gqlEditarContatoAdministrador = gql`
  mutation editarContatoAdministrador(
    $nome: String!
    $email: String!
    $site: String
    $newsletter: Boolean!
    $telefoneDDD: Int
    $telefoneNumero: Int
    $telefoneTipo: Int
    $telefoneRamal: Int
    $celular: TelefoneInput
  ) {
    editarContatoAdministrador(
      contatoAdministrador: {
        nome: { nomeCompleto: $nome }
        email: { enderecoEletronico: $email, newsletter: $newsletter }
        site: { enderecoEletronico: $site, newsletter: $newsletter }
        telefone: {
          ddd: $telefoneDDD
          numero: $telefoneNumero
          tipoTelefone: $telefoneTipo
          ramal: $telefoneRamal
        }
        celular: $celular
      }
    ) {
      email {
        enderecoEletronico
        newsletter
      }
      telefone {
        ddd
        numero
        tipoTelefone
        ramal
      }
      celular {
        ddd
        numero
        tipoTelefone
      }
      site {
        enderecoEletronico
      }
    }
  }
`

// TODO No objeto de contato algumas informações não foram encontradas no graphql
// identificationNumber
// nome.emiteNotaFiscal
// site

const businessMap = {
  nomeFantasia: 'nomeFantasia',
  cnpj: 'cnpj',
  razaoSocial: 'razaoSocial',
  dataConstituicao: 'dataConstituicao',
  formaConstituicao: 'formaConstituicao.longDesc',
  cnaePrincipal: 'cnaePrincipal',
  inscricaoMunicipal: 'inscricaoMunicipal',
  faturamentoMedioMensal: 'faturamentoMedioMensal',
  customerId: 'customerId'
  // pap: 'pap',
}

export const transformBusiness = src => {
  const { contatoAdministrador: contato, usuario, representantes } = src.data
  const { pap } = src
  const { enderecos } = usuario
  const profile = transformObject(usuario, businessMap)
  profile.pap = pap.adesaoPap

  return {
    contato,
    enderecos,
    profile,
    representantes
  }
}

export const transformBusinessUser = src => {
  const { usuario } = src.data
  const { enderecos } = usuario
  const profile = transformObject(usuario, businessMap)

  return {
    enderecos,
    profile
  }
}



// WEBPACK FOOTER //
// ./src/alelo-logic/services/queries/business.js